/**
 * Created by comoon on 8/6/15.
 */

function randomTimeId() {
    return Date.now() * 1000 + Math.ceil(Math.random() * 1000);
}

module.exports = {randomTimeId};


/** WEBPACK FOOTER **
 ** ./script/util/seed.js
 **/